import React from "react";
import AdminGeneralSettingsPage from "./AdminGeneralSettingsPage";

const AdminPreInfoForm = () => <AdminGeneralSettingsPage field="onbilgilendirme" title="Ön Bilgilendirme Formu" />;

export default AdminPreInfoForm;
